























































































































import { Component, Prop, Emit } from "vue-property-decorator";
import CrudDialog from "@/components/dialogs/CrudDialog.vue";
import EventModel from "@/models/event/eventModel";
import EventUpsertModel from "@/models/event/eventUpsertModel";
import EventCategoryModel from "@/models/event/eventCategoryModel";
import UserModel from "@/models/user/userModel";
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/snackbarModule";
import EventService from "@/services/eventService";
import Validation from "@/mixins/validation";
import Clash from "@/components/calendar/Clash.vue";
import moment from "moment";

const snackbarModule = getModule(SnackbarModule);

@Component({
  components: {
    CrudDialog,
    Clash
  }
})
export default class EventDialog extends Validation {
  @Prop(Boolean) readonly dialog!: boolean;
  @Prop(Boolean) readonly isEdit!: boolean;
  @Prop(Object) readonly event!: EventModel;
  @Prop(Array) readonly users!: Array<UserModel>;
  @Prop(Array) readonly categories!: Array<EventCategoryModel>;

  private startDateMenu = false;
  private endDateMenu = false;
  private clashDialog = false;
  private clashes: Array<EventModel> = [];

  private created() {
    this.subscribeToModalOpen();
  }

  private get formattedStartDate(): string {
    return moment(this.event.startDate).format("DD/MM/YYYY");
  }
  private set formattedStartDate(value: string) {
    if (value.length == 10 && moment(value, "DD/MM/YYYY").isValid()) {
      this.event.startDate = value
        ? moment(value, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";
    }
  }
  private get formattedEndDate(): string {
    return moment(this.event.endDate).format("DD/MM/YYYY");
  }
  private set formattedEndDate(value: string) {
    if (value.length == 10 && moment(value, "DD/MM/YYYY").isValid()) {
      this.event.endDate = value
        ? moment(value, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";
    }
  }

  private subscribeToModalOpen(): void {
    this.$root.$on("openNavbarModal", () => {
      this.$emit("update:dialog", true);
    });
  }

  @Emit("get-events")
  private async createEvent(valid: boolean) {
    if (valid) {
      try {
        this.event.calendarId = this.$route.params.id;
        await EventService.createEvent(new EventUpsertModel(this.event));
        snackbarModule.snackSuccess("Event Created");
        this.closeDialog();
      } catch (e) {
        if (e.response.data == "End date must be after start date") {
          alert(e.response.data);
        } else {
          this.clashes = e.response.data;
          this.clashDialog = true;
        }
      }
    }
  }

  @Emit("get-events")
  private async updateEvent(valid: boolean) {
    if (valid) {
      try {
        await EventService.updateEvent(
          this.event.eventId,
          new EventUpsertModel(this.event)
        );
        snackbarModule.snackSuccess("Event updated");
        this.closeDialog();
      } catch (e) {
        if (e.response.data == "End date must be after start date") {
          // TODO handle this error properly
          alert(e.response.data);
        } else {
          this.clashes = e.response.data;
          this.clashDialog = true;
        }
      }
    }
  }

  @Emit("get-events")
  private async deleteEvent() {
    if (confirm("Are you sure you want to delete this Event?")) {
      try {
        await EventService.deleteEvent(this.event.eventId);
        snackbarModule.snackSuccess("Event Deleted");
        this.closeDialog();
      } catch {
        snackbarModule.snackError("Event delete failed, please try again");
      }
    }
  }

  private closeDialog() {
    this.$emit("update:dialog", false);

    setTimeout(() => {
      this.$emit("update:isEdit", false);
      this.$emit("update:event", new EventModel());
    }, 300);
  }
}
